/** The most rows one import takes (D1 bound-parameter and query caps). */
export const IMPORT_MAX_ROWS = 300;
export const POST_CATEGORY_LABELS = {
    'tin-tuc': 'Tin tức',
    'thong-bao': 'Thông báo',
    'su-kien': 'Sự kiện',
};
//# sourceMappingURL=types.js.map